var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tooltip',{attrs:{"label":_vm.$t('schedules.duplicate'),"position":"is-top"}},[_c('Button',{staticClass:"schedule-index-page__action-button",attrs:{"type":"is-light","tag":"a","icon-right":"clone","icon-pack":"far","href":_vm.href},on:{"click":_vm.handleClone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }